import DoublePrizeTicketCard from '../DoublePrizeTicketCard/index';
import SinglePrizeTicketCard from '../SinglePrizeTicketCard';
import TicketCard from '../../TicketCard/TicketCard';

const NewPrizeCard = (props) => {
  const isDoublePrize = props.raffles.length > 1;
  if (isDoublePrize) {
    return <DoublePrizeTicketCard {...props} theme='light' />;
  }
  // return <SinglePrizeTicketCard {...props} theme='light' />;
  return <TicketCard {...props} theme='light' />;
};

export default NewPrizeCard;
